<template>
	<div>
    <v-row no-gutters>
      <vueSignature
        ref="signature"
        :sigOption="option"
        :w="'800px'"
        :h="'170px'"
        :disabled="disabled"
      ></vueSignature>
    </v-row>
    <v-divider></v-divider>
		<v-btn icon @click="clear"><v-icon>mdi-refresh-circle</v-icon></v-btn>
	</div>
</template>

<script>
import vueSignature from "vue-signature"

export default {
  name: "Signature",
  components: {
    vueSignature
  },
	data() {
		return {
			option: {
				penColor: "rgb(0, 0, 0)",
				backgroundColor: "rgb(255,255,255)",
				throttle: 0,
				minDistance: 0
			},
			disabled: false,
			dataUrl: "https://avatars2.githubusercontent.com/u/17644818?s=460&v=4",
		};
	},
	methods: {
		save() {
			var _this = this;
      var png = _this.$refs.signature.save();
      return png;
			//var jpeg = _this.$refs.signature.save("image/jpeg");
			//var svg = _this.$refs.signature.save("image/svg+xml");
			//console.log(png);
			//console.log(jpeg);
			//console.log(svg);
		},
		clear() {
			var _this = this;
			_this.$refs.signature.clear();
		},
		undo() {
			var _this = this;
			_this.$refs.signature.undo();
		},
		fromDataURL() {
			var _this = this;
			_this.$refs.signature.fromDataURL("data:image/png;base64,iVBORw0K...");
    },
    isEmpty() {
      return this.$refs.signature.isEmpty();
    }
	},
};
</script>